import { render } from "./Year.vue?vue&type=template&id=132c6601&scoped=true"
import script from "./Year.vue?vue&type=script&lang=js"
export * from "./Year.vue?vue&type=script&lang=js"

import "./Year.vue?vue&type=style&index=0&id=132c6601&scoped=true&lang=css"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132c6601"]])

export default __exports__